export default "__VITE_ASSET__CfnyGqPF__"